import unfetch from 'isomorphic-unfetch'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

export const APIKey =
  publicRuntimeConfig.googleAPIKey !== '' ? publicRuntimeConfig.googleAPIKey : process.env.GOOGLE_API_KEY

const GEOCODE_ENDPOINT = 'https://maps.googleapis.com/maps/api/geocode/json'

export interface GeoLocation {
  readonly lat: number
  readonly lng: number
}

export async function getGeoLocationFromAddress(address: string): Promise<GeoLocation | null> {
  const reqURL = new URL(GEOCODE_ENDPOINT)
  reqURL.searchParams.append('address', address)
  reqURL.searchParams.append('key', APIKey)

  /** Do not use ./request because not set x-csrf-token header. For client side call cases. */
  let response = null
  try {
    response = await unfetch(String(reqURL))
    if (!response.ok) {
      return null
    }
  } catch (error) {
    return null
  }

  const json = await response.json()
  return json.results.length > 0 ? fromJSON(json) : null
}

function fromJSON(json: any): GeoLocation {
  const result = json.results
  const location = result[0].geometry.location

  return { lat: location.lat, lng: location.lng }
}
